export default function getIndexName(index: string): string {
  return `${index}_${process.env.ALGOLIA_ENV}`;
}
